const messages = {
  select: {
    required: 'Chọn từ danh sách',
    default: 'Chọn...'
  },
  input: {
    required: 'Nhập nội dung',
    invalid: 'Không hợp lệ',
    invalidDate: 'Nhập giá trị theo định dạng DD/MM/YYYY, vd: 31/12/2019'
  },
  login: {
    error: {
      INVALID_CREDENTIAL: 'Tên đăng nhập hoặc mật khẩu không hợp lệ',
      default: 'Tên đăng nhập hoặc mật khẩu không hợp lệ'
    }
  }
};

export default messages;
